import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { gallery, galleryCategories } from "@/config/content";
import { Reveal } from "@/lib/motion";

export const Gallery = () => {
  const [filter, setFilter] = useState("Alle");
  const items = filter === "Alle" ? gallery : gallery.filter((g) => g.cat === filter);

  return (
    <section className="py-20 lg:py-28 bg-sand grain relative" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <Reveal className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-dark mb-4">Leistungsbereiche</p>
          <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-charcoal leading-[1.15]">
            Unsere Leistungsbereiche
          </h2>
          <p className="mt-5 text-lg text-charcoal-muted leading-relaxed">
            Ein Überblick über unsere Leistungsbereiche rund um Reinigung, Objektpflege und Ausbau.
          </p>
        </Reveal>

        <div className="mt-8 flex flex-wrap gap-2.5" role="tablist" aria-label="Galerie filtern">
          {galleryCategories.map((c) => (
            <button
              key={c}
              role="tab"
              aria-selected={filter === c}
              data-testid={`gallery-filter-${c}`}
              onClick={() => setFilter(c)}
              className={`rounded-full px-4 py-2 text-sm font-medium border transition-colors duration-200 ${
                filter === c ? "bg-forest text-white border-forest" : "bg-white text-charcoal-muted border-border hover:border-forest hover:text-forest"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <motion.div layout className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <AnimatePresence mode="popLayout">
            {items.map((g) => (
              <motion.figure
                layout
                key={g.src}
                initial={{ opacity: 0, scale: 0.96 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.96 }}
                transition={{ duration: 0.35 }}
                data-testid="gallery-item"
                className="group relative rounded-xl overflow-hidden border border-border bg-white aspect-[4/3]"
              >
                <img src={g.src} alt={g.alt} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <figcaption className="absolute top-2.5 left-2.5 text-[11px] bg-white/90 text-forest font-medium rounded-md px-2 py-0.5 border border-border">{g.cat}</figcaption>
              </motion.figure>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
};
